var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    { ref: "base", attrs: { "max-width": "300px" } },
    [
      _c(
        "v-card",
        { attrs: { "min-height": "80vh" } },
        [
          _c("v-card-title", [_vm._v("Запрос")]),
          _c("v-card-subtitle", [
            _vm.payment.refund
              ? _c("span", [_vm._v("На возврат денежных средств")])
              : _c("span", [_vm._v("На пополнение баланса")]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.client.full_name,
                    expression: "client.full_name",
                  },
                ],
              },
              [
                _vm._v(
                  "№" +
                    _vm._s(_vm.client.number) +
                    " " +
                    _vm._s(_vm.client.full_name)
                ),
              ]
            ),
          ]),
          _c(
            "v-card-text",
            [
              _c("div", { staticClass: "font-weight-medium" }, [
                _vm._v("Интрукция:"),
              ]),
              _c(
                "div",
                {
                  staticClass: "mb-3",
                  staticStyle: { "white-space": "pre-wrap" },
                },
                [_vm._v(_vm._s(_vm.shop.add_balance_instruction))]
              ),
              _vm.payment.refund
                ? _c("div", { staticClass: "pb-3" }, [
                    _vm._v(" Ваш текущий баланс "),
                    _c("span", { staticClass: "font-weight-medium" }, [
                      _vm._v(_vm._s(_vm.current_client.balance) + "₽"),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-text-field",
                    {
                      directives: [
                        {
                          name: "only-number",
                          rawName: "v-only-number.float",
                          modifiers: { float: true },
                        },
                      ],
                      attrs: {
                        dense: "",
                        rules: _vm.rules.value,
                        outlined: "",
                        label: "Сумма",
                        hint: _vm.payment.refund
                          ? "Должна быть не больше баланса"
                          : "Укажите сумму из чека!",
                      },
                      model: {
                        value: _vm.payment.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.payment, "value", _vm._n($$v))
                        },
                        expression: "payment.value",
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            slot: "append",
                            size: "21",
                            color: "lightgray",
                          },
                          slot: "append",
                        },
                        [_vm._v(_vm._s(_vm.icon_rub))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-container",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.payment.refund,
                          expression: "!payment.refund",
                        },
                      ],
                      staticClass: "py-0",
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "text-center pt-0 px-0" },
                            [
                              _vm.payment.image_url !== null
                                ? _c("v-img", {
                                    staticStyle: {
                                      border: "1px solid #f2f2f2",
                                      "border-radius": "15px",
                                    },
                                    attrs: { src: _vm.payment.image_url },
                                  })
                                : _c("image-input", {
                                    attrs: { quality: 0.9 },
                                    on: { success: _vm.setCheck },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function ({ onInputClick }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "btn",
                                                staticStyle: {
                                                  height: "120px",
                                                  "border-radius":
                                                    "5px !important",
                                                },
                                                attrs: { block: "" },
                                                on: { click: onInputClick },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          size: "40",
                                                          color:
                                                            "rgba(0,0,0,.4)",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.icon_plus)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "pt-2",
                                                        staticStyle: {
                                                          color:
                                                            "rgba(0,0,0,.4)",
                                                        },
                                                      },
                                                      [_vm._v("Прикрепить чек")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.payment.image_url === null &&
                            !_vm.payment.refund,
                          expression:
                            "payment.image_url===null&&!payment.refund",
                        },
                      ],
                      staticClass: "caption px-3 mt-n3 pb-3",
                    },
                    [_vm._v(" Необходимо прикрепить чек ")]
                  ),
                  _c("v-textarea", {
                    attrs: {
                      dense: "",
                      "no-resize": "",
                      rows: "4",
                      outlined: "",
                      label: "Комментарий",
                      hint: "Не обязательно",
                      clearable: "",
                    },
                    model: {
                      value: _vm.payment.comment,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.payment,
                          "comment",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "payment.comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-1 pt-2 text-right",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn btn-h mr-2",
                              attrs: { width: "108", disabled: _vm.loading },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.base.hide()
                                },
                              },
                            },
                            [_vm._v(" Отмена ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: {
                                width: "108",
                                loading: _vm.loading,
                                disabled:
                                  !_vm.valid ||
                                  (_vm.payment.image_url === null &&
                                    !_vm.payment.refund),
                                color: "success",
                              },
                              on: { click: _vm.sendPayment },
                            },
                            [_vm._v("Отправить ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }